import { cn } from '@/lib/cn'
import styles from './Skeleton.module.css'

interface SkeletonProps {
  width?: string | number
  height?: string | number
  radius?: string
  className?: string
}

export function Skeleton({ width, height = 16, radius, className }: SkeletonProps) {
  return (
    <span
      className={cn(styles.skeleton, className)}
      style={{ width, height, borderRadius: radius }}
      aria-hidden="true"
    />
  )
}

/**
 * Placeholder rows shaped like the table they replace.
 *
 * Matching the real layout is the point: the page keeps its height while data
 * loads, so nothing jumps when the rows arrive.
 */
export function TableSkeleton({ rows = 8, columns = 6 }: { rows?: number; columns?: number }) {
  return (
    <div className={styles.table} role="status" aria-label="Loading records">
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div className={styles.row} key={rowIndex}>
          {Array.from({ length: columns }).map((__, columnIndex) => (
            <Skeleton
              key={columnIndex}
              height={12}
              // Varying widths read as text rather than as a block of bars.
              width={columnIndex === 0 ? '42%' : columnIndex % 3 === 0 ? '68%' : '84%'}
            />
          ))}
        </div>
      ))}
      <span className="visually-hidden">Loading records</span>
    </div>
  )
}

export function CardSkeleton({ height = 120 }: { height?: number }) {
  return (
    <div className={styles.card} style={{ minHeight: height }} role="status" aria-label="Loading">
      <Skeleton width="45%" height={10} />
      <Skeleton width="65%" height={26} />
      <Skeleton width="35%" height={10} />
    </div>
  )
}
